import axiosInstance from "../../axios/axios";
import QueryResponse from "./shared models/QueryResponse";
import { requestHeader } from "./sharedUtils";
import StepDto from "./dtos/StepDto";

export const getAllSteps = async (): Promise<
  [QueryResponse<StepDto[]> | null, unknown]
> => {
  try {
    const response = await axiosInstance.get<QueryResponse<StepDto[]>>(
      `/Steps`,
      requestHeader
    );
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const getStepGroups = async (): Promise<
  [string[] | null, unknown]
> => {
  try {
    const response = await axiosInstance.get<QueryResponse<string[]>>(
      `/StepGroups`,
      requestHeader
    );
    return [response.data.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const updateStep = async (
  step: StepDto
): Promise<[QueryResponse<StepDto[]> | null, unknown]> => {
  try {
    const response = await axiosInstance.post<QueryResponse<StepDto[]>>(
      `/UpdateStep`,
      step,
      requestHeader
    );
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};
